import React, { useCallback, useMemo } from 'react';
import { Box, Button } from '@material-ui/core';
import { Text } from '../../../../atoms';

const ModalDetailsEvent = ({ contentModal = {}, onClose }) => {
    

    const capitalizeFirst = (value) => {
        if (!value && value !== 0) return value;
        const str = String(value);
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const formatDateRange = (start, end) => {
        try {
            const s = new Date(start);
            const f = new Date(end);
            const weekday = s.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '').toUpperCase();
            const day = String(s.getDate()).padStart(2, '0');
            const month = s.toLocaleDateString('pt-BR', { month: 'short' }).toUpperCase();
            const optionsTime = { hour: '2-digit', minute: '2-digit' };
            const startTime = s.toLocaleTimeString('pt-BR', optionsTime);
            const endTime = f.toLocaleTimeString('pt-BR', optionsTime);
            return `${weekday}, ${day} ${month} • ${startTime} às ${endTime}`;
        } catch (e) {
            return '';
        }
    };
    const isMeeting = useMemo(() => contentModal.type === 'Meeting', [contentModal.type]);

    const renderSpeaker = useCallback((speaker, style = { fontSize: 14, fontWeight: 'bold' }) => {
        return <div style={style}>{`Nome do condutor: ${capitalizeFirst(speaker)}`}</div>;
    }, []);
    const renderAddress = useCallback((address, meetingType) => {
        return (
            <>
                {meetingType === 'ONLINE' ? (
                    <a href={contentModal.address} target="_blank" rel="noopener noreferrer">
                        {address}
                    </a>
                ) : (
                    <div>
                        <span style={{ fontSize: '14px' }}>Endereço: {address}</span>
                    </div>
                )}
            </>
        );
    }, []);
    return (
        <Box
            sx={{
                position: 'absolute',
                top: '40%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: isMeeting ? '40%' : '70%' },
                bgcolor: 'background.paper',
                p: 4,
            }}
        >
            <Text component="h2" text={capitalizeFirst(contentModal.title)} />
            {!isMeeting && <Text component="p" text={`<b>Data: </b> ${contentModal.data}`} />}
            {isMeeting && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                        marginTop: '2rem 0',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text
                            component="p"
                            style={{ fontWeight: 'bold' }}
                            text={formatDateRange(contentModal.startDate, contentModal.finishDate)}
                        />
                        <span className="button-event">{contentModal.meetingType.toUpperCase()}</span>
                    </div>
                    {contentModal.speaker &&
                        renderSpeaker(contentModal.speaker, { fontSize: 14, fontWeight: 'normal' })}
                    {contentModal.address && renderAddress(contentModal.address, contentModal.meetingType)}
                </div>
            )}
            {contentModal.tipo && <Text component="p" text={`<b>Tipo: </b> ${capitalizeFirst(contentModal.tipo)}`} />}

            {contentModal.url && (
                <p>
                    <b>Url: </b>
                    <a href={contentModal.url} target="_blank" rel="noopener noreferrer">
                        {contentModal.url}
                    </a>
                </p>
            )}

            {contentModal.descricao && (
                <Text component="p" text={`<b>Descrição: </b> ${capitalizeFirst(contentModal.descricao)}`} />
            )}

            {Array.isArray(contentModal.meetings) && contentModal.meetings.length > 0 && (
                <div className="modal-meetings">
                    {contentModal.meetings.map((m, index) => (
                        <div
                            key={m.idMeeting}
                            className="meeting-row"
                        >
                            <strong className="encontros">
                                {capitalizeFirst(
                                    contentModal.meetings.length > 1
                                        ? `Encontros ${index + 1}`
                                        : `Encontro ${index + 1}`,
                                )}
                            </strong>
                            <div className='date-info'>
                                {formatDateRange(m.startDate, m.finishDate)}
                            </div>

                            {m.meetingType && (
                                <span className="button-event">{capitalizeFirst(m.meetingType.toLowerCase())}</span>
                            )}

                            {m.speaker && renderSpeaker(m.speaker)}
                        </div>
                    ))}
                </div>
            )}

            <div className="containerBtnModal">
                <Button onClick={onClose}>Fechar</Button>
            </div>
        </Box>
    );
};

export default ModalDetailsEvent;
